// Shared "Sehstärke übermitteln" step (Werte eingeben / Hochladen / Später)
// for all BD lens-selection modals. Renders/behaves identically everywhere
// via markup from snippets/bd-rx-step.liquid, mounted per-modal with a
// unique id prefix. Tapping an option advances immediately — no separate
// "Weiter" confirmation for the top-level choice.
window.BdRxStep = (function () {
  function buildSelect(sel, from, to, step, fmt) {
    if (!sel) return;
    sel.innerHTML = '<option value="">—</option>';
    for (let v = from; v <= to + 0.0001; v += step) {
      v = Math.round(v * 10000) / 10000;
      const opt = document.createElement("option");
      opt.value = String(v);
      opt.textContent = fmt(v);
      sel.appendChild(opt);
    }
  }
  const fmtSph = (v) => (v > 0 ? "+" : "") + v.toFixed(2);
  const fmtInt = (v) => String(Math.round(v));
  const fmtPd = (v) => v.toFixed(1);

  // -----------------------
  // Custom dropdown skin over a native <select> — a small, contained panel
  // positioned under the field (like Mia Burton's SPH/PD pickers), instead
  // of the browser's full-screen native option list. The native <select>
  // stays in the DOM (hidden) so all existing .value / "change" logic
  // (validateEnter, BdPd's confirmManual writing straight into it, etc.)
  // keeps working unchanged — this only adds a visual layer on top.
  // -----------------------
  const openPanels = [];
  function closeAllPanels() {
    openPanels.forEach(({ wrapper, panel }) => {
      panel.hidden = true;
      wrapper.classList.remove("is-open");
    });
    openPanels.length = 0;
  }
  document.addEventListener("click", closeAllPanels);
  window.addEventListener("resize", closeAllPanels);

  function enhanceSelect(select) {
    if (!select || select.dataset.enhanced) return;
    select.dataset.enhanced = "true";

    const wrapper = document.createElement("div");
    wrapper.className = "bd-customselect";
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    select.classList.add("bd-customselect__native");
    select.tabIndex = -1;

    const trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "bd-customselect__trigger";
    trigger.innerHTML =
      '<span class="bd-customselect__value bd-customselect__value--placeholder">—</span>' +
      '<svg class="bd-customselect__chev" width="11" height="11" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    wrapper.appendChild(trigger);
    const valueEl = trigger.querySelector(".bd-customselect__value");

    const panel = document.createElement("div");
    panel.className = "bd-customselect__panel";
    panel.hidden = true;
    wrapper.appendChild(panel);

    function renderOptions() {
      panel.innerHTML = "";
      Array.prototype.forEach.call(select.options, (opt) => {
        if (opt.value === "") return;
        const b = document.createElement("button");
        b.type = "button";
        b.className = "bd-customselect__opt";
        b.textContent = opt.textContent;
        b.dataset.value = opt.value;
        if (opt.value === select.value) b.classList.add("is-selected");
        b.addEventListener("click", (e) => {
          // Both this button and the hidden native <select> live inside the
          // same <label> — without stopping propagation here, the browser's
          // default label→control forwarding would also fire a click on the
          // (invisible) select, occasionally popping its native picker.
          e.stopPropagation();
          select.value = opt.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
          closeAllPanels();
        });
        panel.appendChild(b);
      });
    }

    function updateLabel() {
      const opt = select.options[select.selectedIndex];
      const hasValue = select.value !== "";
      valueEl.textContent = hasValue && opt ? opt.textContent : "—";
      valueEl.classList.toggle("bd-customselect__value--placeholder", !hasValue);
      panel.querySelectorAll(".bd-customselect__opt").forEach((b) => {
        b.classList.toggle("is-selected", b.dataset.value === select.value);
      });
    }
    select.addEventListener("change", updateLabel);

    function positionPanel() {
      const r = trigger.getBoundingClientRect();
      panel.style.left = r.left + "px";
      panel.style.top = r.bottom + 4 + "px";
      panel.style.width = r.width + "px";
    }

    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      const wasOpen = !panel.hidden;
      closeAllPanels();
      if (wasOpen) return;
      renderOptions();
      positionPanel();
      panel.hidden = false;
      wrapper.classList.add("is-open");
      const sel = panel.querySelector(".is-selected");
      if (sel) sel.scrollIntoView({ block: "nearest" });
      openPanels.push({ wrapper, panel });
    });

    updateLabel();
  }

  // config: { prefix, onBack, onComplete }
  function mount(config) {
    const p = config.prefix;
    const byId = (suffix) => document.getElementById(p + suffix);

    const stepChoice = byId("StepChoice");
    const stepEnter = byId("StepEnter");
    const stepUpload = byId("StepUpload");
    if (!stepChoice || !stepEnter || !stepUpload) return null;

    const choiceBack = byId("ChoiceBack");
    const optEnter = byId("OptEnter");
    const optUpload = byId("OptUpload");
    const optLater = byId("OptLater");

    const sphR = byId("SphR"), sphL = byId("SphL");
    const cylR = byId("CylR"), cylL = byId("CylL");
    const axisR = byId("AxisR"), axisL = byId("AxisL");
    const pdR = byId("PdR"), pdL = byId("PdL");
    const pdTotal = byId("PdTotal");
    const pdTotalWrap = byId("PdTotalWrap");
    const pdSplitWrap = byId("PdSplitWrap");
    const pdTwoToggle = byId("PdTwoToggle");
    const pdMeasureBtn = byId("PdMeasureBtn");
    const pdNote = byId("PdNote");
    const pdNoteReset = byId("PdNoteReset");
    const pdNotesWrap = byId("PdNotesWrap");
    const enterNext = byId("EnterNext");
    const enterBack = byId("EnterBack");

    let pdDeferred = false;
    let pdPhotoInput = null;

    const rxFile = byId("RxFile");
    const uploadNext = byId("UploadNext");
    const uploadBack = byId("UploadBack");
    const uploadFilename = byId("UploadFilename");
    const uploadZone = byId("UploadZone");

    buildSelect(sphR, -10, 10, 0.25, fmtSph);
    buildSelect(sphL, -10, 10, 0.25, fmtSph);
    buildSelect(cylR, -10, 10, 0.25, fmtSph);
    buildSelect(cylL, -10, 10, 0.25, fmtSph);
    buildSelect(axisR, 0, 180, 1, fmtInt);
    buildSelect(axisL, 0, 180, 1, fmtInt);
    buildSelect(pdR, 17.5, 40, 0.5, fmtPd);
    buildSelect(pdL, 17.5, 40, 0.5, fmtPd);
    buildSelect(pdTotal, 35, 80, 0.5, fmtPd);

    [sphR, sphL, cylR, cylL, axisR, axisL, pdTotal, pdR, pdL].forEach(enhanceSelect);
    if (stepEnter) stepEnter.addEventListener("scroll", closeAllPanels);

    function hideAll() {
      [stepChoice, stepEnter, stepUpload].forEach((s) => { if (s) s.style.display = "none"; });
    }

    function show() {
      hideAll();
      stepChoice.style.display = "block";
      if (rxFile) rxFile.value = "";
    }

    function formatSPH(val) {
      const n = parseFloat(val);
      return isNaN(n) ? "" : (n > 0 ? "+" : "") + n.toFixed(2);
    }

    function validateEnter() {
      const sphOk = sphR && sphR.value !== "" && sphL && sphL.value !== "";
      let pdOk;
      if (pdDeferred) {
        pdOk = true;
      } else if (pdTwoToggle && pdTwoToggle.checked) {
        pdOk = pdR && pdR.value !== "" && pdL && pdL.value !== "";
      } else {
        pdOk = pdTotal && pdTotal.value !== "";
      }
      if (enterNext) enterNext.disabled = !(sphOk && pdOk);
    }
    [sphR, sphL, pdR, pdL, pdTotal, cylR, cylL, axisR, axisL].forEach((el) => {
      if (el) el.addEventListener("change", validateEnter);
    });

    // -----------------------
    // PD: single "Gesamt-PD" vs. two per-eye values, plus the "PD unbekannt?"
    // helper that reuses the existing (dormant since 2026-08-20) window.BdPd
    // photo/manual-measurement tool instead of a fake "instant" link.
    // -----------------------
    function syncPdMode() {
      const twoMode = !!(pdTwoToggle && pdTwoToggle.checked);
      if (pdTotalWrap) pdTotalWrap.style.display = twoMode ? "none" : "";
      if (pdSplitWrap) pdSplitWrap.style.display = twoMode ? "grid" : "none";
      if (pdNotesWrap) pdNotesWrap.style.display = twoMode ? "block" : "none";
      if (pdMeasureBtn) pdMeasureBtn.style.display = twoMode || pdDeferred ? "none" : "flex";
      validateEnter();
    }
    if (pdTwoToggle) pdTwoToggle.addEventListener("change", syncPdMode);

    function resetPdDeferred() {
      pdDeferred = false;
      pdPhotoInput = null;
      if (pdNote) { pdNote.style.display = "none"; pdNote.textContent = ""; }
      if (pdNoteReset) pdNoteReset.style.display = "none";
      syncPdMode();
    }
    if (pdNoteReset) pdNoteReset.addEventListener("click", resetPdDeferred);

    if (pdMeasureBtn) {
      pdMeasureBtn.addEventListener("click", function () {
        if (!window.BdPd) return;
        const wizRight = stepEnter.closest(".bd-wiz-right") || stepEnter.parentElement;
        window.BdPd.open({
          hostPanel: wizRight,
          currentStepEl: stepEnter,
          startStep: "prep",
          fieldIds: { r: p + "PdR", l: p + "PdL" },
          confirmNoteEl: pdNote,
          // Customer uploads/takes a photo — we read the PD off it afterwards,
          // they can't know the number themselves right now. Skip the PD
          // requirement instead of pretending we can validate it live.
          onPhotoAttached: function (inputEl) {
            pdPhotoInput = inputEl;
            pdDeferred = true;
            if (pdNoteReset) pdNoteReset.style.display = "inline";
            syncPdMode();
          },
          // Customer typed a number they already know (BdPd's own manual step
          // supports a single combined value or two per-eye values) — always
          // lands in our two-field display since BdPd always writes both.
          onManualConfirmed: function () {
            pdDeferred = false;
            pdPhotoInput = null;
            if (pdTwoToggle) pdTwoToggle.checked = true;
            if (pdNoteReset) pdNoteReset.style.display = "inline";
            syncPdMode();
          },
        });
      });
    }

    function validateUpload() {
      if (uploadNext) uploadNext.disabled = !(rxFile && rxFile.files && rxFile.files.length);
    }
    if (rxFile) {
      rxFile.addEventListener("change", function () {
        validateUpload();
        if (uploadFilename) uploadFilename.textContent = rxFile.files[0] ? rxFile.files[0].name : "";
        if (uploadZone) uploadZone.classList.toggle("has-file", !!rxFile.files[0]);
      });
    }

    if (choiceBack) {
      choiceBack.addEventListener("click", () => {
        hideAll();
        if (typeof config.onBack === "function") config.onBack();
      });
    }

    if (optEnter) {
      optEnter.addEventListener("click", () => {
        hideAll();
        stepEnter.style.display = "block";
        validateEnter();
      });
    }

    if (optUpload) {
      optUpload.addEventListener("click", () => {
        hideAll();
        stepUpload.style.display = "block";
        validateUpload();
      });
    }

    if (optLater) {
      optLater.addEventListener("click", () => {
        config.onComplete({ "Sehstärke": "Wird später per E-Mail eingereicht" }, null);
      });
    }

    if (enterBack) enterBack.addEventListener("click", show);
    if (uploadBack) uploadBack.addEventListener("click", show);

    if (enterNext) {
      enterNext.addEventListener("click", () => {
        const props = { "Sehstärke übermittelt": "Eingabe" };
        if (sphR && sphR.value !== "") props["SPH Rechts"] = formatSPH(sphR.value);
        if (sphL && sphL.value !== "") props["SPH Links"] = formatSPH(sphL.value);
        if (cylR && cylR.value !== "") props["CYL Rechts"] = formatSPH(cylR.value);
        if (cylL && cylL.value !== "") props["CYL Links"] = formatSPH(cylL.value);
        if (axisR && axisR.value !== "") props["Achse Rechts"] = axisR.value + "°";
        if (axisL && axisL.value !== "") props["Achse Links"] = axisL.value + "°";

        if (pdDeferred) {
          props["PD"] = "Wird aus eingereichtem Foto ermittelt";
        } else if (pdTwoToggle && pdTwoToggle.checked) {
          if (pdR && pdR.value !== "") props["PD Rechts"] = pdR.value + " mm";
          if (pdL && pdL.value !== "") props["PD Links"] = pdL.value + " mm";
          const notes = byId("PdNotes");
          if (notes && notes.value.trim() !== "") props["PD Notizen"] = notes.value.trim();
        } else if (pdTotal && pdTotal.value !== "") {
          const half = Math.round((parseFloat(pdTotal.value) / 2) * 2) / 2;
          props["PD Rechts"] = half.toFixed(1) + " mm";
          props["PD Links"] = half.toFixed(1) + " mm";
          props["PD Eingabe"] = "Gesamt " + pdTotal.value + " mm (hälftig aufgeteilt)";
        }

        config.onComplete(props, pdDeferred ? pdPhotoInput : null);
      });
    }

    if (uploadNext) {
      uploadNext.addEventListener("click", () => {
        if (!rxFile || !rxFile.files || !rxFile.files.length) return;
        config.onComplete({ "Sehstärke übermittelt": "Sehtest Upload" }, rxFile);
      });
    }

    return { show, hide: hideAll };
  }

  return { mount };
})();
